const LISTING_TYPE = {

  id: "listing_type",
  type: "dropdown",
  props: {
    dropdownProps: {
      label: "Listing Type",
      buttonProps: {
        className: "listing_type",
      },
      menuProps: {
        style: {
          // minWidth: 300
        }
      }
    },
    options: [
      { label: "Sale", value: "For Sale" },
      { label: "Rent", value: "For Rent" },
    ],
  }

}

const COL_LISTING_TYPE = {

  id: "col_listing_type",
  type: "col",
  props: {
    lg: 3,
    md: 4,
    xs: 6,
  },
  children: [LISTING_TYPE]

}

const COL_MODAL_LISTING_TYPE = {

  id: "col_listing_type",
  type: "col",
  props: {
    lg: 6,
    md: 6,
    xs: 6,
  },
  children: [LISTING_TYPE]

}

export { LISTING_TYPE, COL_LISTING_TYPE, COL_MODAL_LISTING_TYPE };
